import { useEffect, useState } from 'react';
import ROUTES from '../../../constants/routes';

const useNewInteractive = () => {
    const [isNewInteractive, setIsNewInteractive] = useState(false);

    useEffect(() => {
        setIsNewInteractive(
            [
                ROUTES.NEW_INTERACTIVE_MATERIALS.path,
                ROUTES.NEW_INTERACTIVE_MY_MATERIALS.path,
                ROUTES.NEW_INTERACTIVE_ROOMS.path,
                ROUTES.NEW_INTERACTIVE_COURSES.path
            ].some((route) => decodeURIComponent(window.location.pathname).includes(route))
        );
    }, [window.location.pathname]);

    return isNewInteractive;
};

export default useNewInteractive;
